/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useRef, useEffect} from 'react';
import {ContentHeader} from '@components';
import {DateTimePicker} from 'react-tempusdominus-bootstrap';
import {Form, Table, Button} from 'react-bootstrap';
import * as AuthService from '../services/auth';
import ClockLoader from 'react-spinners/ClockLoader';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
const Zoom = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [input, setInput] = useState({
    zoom_id: '',
    zoom_email: '',
    zoom_date_time: null,
    sf_id: ''
  });

  const [zoom, setZoom] = useState([]);
  const [loading, setLoading] = useState(false);
  const [temp, setTemp] = useState('');

  function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  function formatTimeToHHMMSS(date) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    console.log(`${hours}:${minutes}:${seconds}`);
    return `${hours}:${minutes}:${seconds}`;
  }

  const downloadZoomLink = async (where) => {
    setLoading(true);
    try {
      if (where === 'sf') {
        const url = await AuthService.getUrlFromSf(input.sf_id);
        console.log(url);
        const zoom = await AuthService.getVdoWs(url.url);
        console.log(zoom);
        setZoom(
          zoom.result.filter((e) => e.zoom_vdo_type === 'active_speaker')
        );
      }
      if (where === 'zoom') {
        const url = `https://api-zoom-v2.advanceagro.net/zoomapi/view/vdo?duration=5&date=${formatDateToYYYYMMDD(
          input.zoom_date_time
        )}&zoom_id=${input.zoom_id}&zoom_host=${
          input.zoom_email
        }&time=${formatTimeToHHMMSS(input.zoom_date_time)}`;
        setTemp(url);
        const zoom = await AuthService.getVdoWs(url);
        console.log(zoom);
        setZoom(
          zoom.result.filter((e) => e.zoom_vdo_type === 'active_speaker')
        );
      }
    } catch (error: any) {
      // dispatch(logoutUser());
      // navigate('/login');
      // window.location.href = '/login';
      toast.error("VDO(s) not found.");
      setZoom([]);
    }
    setLoading(false);
  };

  return (
    <div>
      <ContentHeader title="Get Zoom VDO" />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className={loading ? 'overlay dark' : 'd-none'}>
              <ClockLoader color="#c4c4c4" />
            </div>
            <div className="card-header">
              Fill Zoom No, Zoom Account, Date-Time | or Saleforce Visit ID
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 row">
                  <Form.Group className="mb-3 col-md-6">
                    <Form.Label>Zoom No</Form.Label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => {
                          setInput((prevState) => ({
                            ...prevState,
                            zoom_id: e.target.value
                          }));
                        }}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group className="mb-3 col-md-6">
                    <Form.Label>Date-Time</Form.Label>
                    <DateTimePicker
                      format="YYYY-MM-DD HH:mm"
                      onChange={(e: any) => {
                        setInput((prevState) => ({
                          ...prevState,
                          zoom_date_time: e.date.toDate()
                        }));
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3 col-md-8">
                    <Form.Label>Zoom Account</Form.Label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => {
                          setInput((prevState) => ({
                            ...prevState,
                            zoom_email: e.target.value
                          }));
                        }}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group className="mb-3 col-md-4">
                    <Form.Label>&nbsp;</Form.Label>
                    <div className="input-group">
                      <Button
                        variant="success"
                        className="col-12"
                        onClick={async () => {
                          await downloadZoomLink('zoom');
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  </Form.Group>
                  <hr className="col-5" />
                  {'OR'}
                  <hr className="col-5" />
                  <Form.Group className="mb-3 col-md-8">
                    <Form.Label>Saleforce Visit ID</Form.Label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => {
                          setInput((prevState) => ({
                            ...prevState,
                            sf_id: e.target.value
                          }));
                        }}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group className="mb-3 col-md-4">
                    <Form.Label>&nbsp;</Form.Label>
                    <div className="input-group">
                      <Button
                        className="col-12"
                        onClick={async () => {
                          await downloadZoomLink('sf');
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  </Form.Group>
                </div>

                <div className="col-12 col-md-6 row">
                  <Form.Group className="mb-3 col-md-12">
                    <Form.Label>Date-Time. and Links</Form.Label>
                    {/* {temp} */}
                    {zoom && zoom.length > 0 ? (
                      zoom.map((e: any, i) => (
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div
                              className="input-group-text form-control"
                              style={{width: 200}}
                            >
                              {e.zoom_date_time}
                            </div>
                          </div>
                          <label
                            className="form-control"
                            style={{
                              textAlign: 'center',
                              verticalAlign: 'center',
                              backgroundColor: 'white'
                            }}
                          >
                            <a href={e.zoom_play_url} target="_blank">
                              Click
                            </a>
                          </label>
                        </div>
                      ))
                    ) : (
                      <></>
                    )}
                  </Form.Group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Zoom;
